import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Container,
    Row,
    Collapse,
    Button,
    CardBody,
    Card,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap';
import ReactAudioPlayer from 'react-audio-player';
import classNames from 'classnames';

class Context extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            collapse: false
        };
    }

    toggle = () => {
        this.setState({collapse: !this.state.collapse});
    }


    modalToggle() {
        this.setState({
            modal: !this.state.modal,
        });
    };

    onScriptCollapse() {
        this.setState({
            collapse: !this.state.collapse,
        });
    };

    render() {
        let fakeSrc="http://delta.mylearningmyway.com/wp-content/uploads/2013/12/message-11.mp3";

        const contextCls = classNames(this.props.className);

        return (<React.Fragment>
            <div className={contextCls} onClick={()=>this.modalToggle()}>
                <span className="play-icon"><img src="/wp-content/plugins/terabit-mlmv-eztop/assets/images/play-icon.svg"/></span>
                {this.props.showingLabel && <br/>}
                {this.props.showingLabel && this.props.label}
            </div>

            <Modal isOpen={this.state.modal} toggle={() => this.modalToggle()} className={"ezTop"}>
                <ModalHeader toggle={() => this.modalToggle()}>{this.props.label || "Audio"}</ModalHeader>
                <ModalBody>
                    <Container>
                        <Row className={"justify-content-md-center"}>
                            <ReactAudioPlayer
                                controlsList = {"nodownload"}
                                src={this.props.audio}
                                hidePlayer={true}
                                controls
                            />
                        </Row>
                        <Row className={"justify-content-md-center"}>
                            <Collapse isOpen={this.state.collapse}>
                                <Card>
                                    <CardBody>
                                        {this.props.script}
                                    </CardBody>
                                </Card>
                            </Collapse>
                        </Row>
                    </Container>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => this.onScriptCollapse()}>Script</Button>
                    <Button color="secondary" onClick={() => this.modalToggle()}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>)

    }
}


Context.propTypes = {
    label: PropTypes.string,
    audio: PropTypes.string.isRequired,
    script: PropTypes.string.isRequired
};


export default Context;



